<template>
    <div>
        <Mainlayout></Mainlayout>
        <CCol sm="12" class="bg-white">
            <br /><br /><br />
            <CCol sm="8" style="width: 80%; background-size: cover; margin: auto; color: #fff" class="d-sm-down-none">
                <br /><br /><br />
                <CRow>
                    <CCol sm="12">
                        <CCard class="bg-white border-grey-card b-20">
                            <CRow class="p-20 m-3">
                                <CCol sm="12">
                                    <h4 class="custom-24px-600 font-color-171717 font-general-sans mb-5 mt-3">Edit Profile Information</h4>
                                </CCol>
                                <CCol sm="2">
                                    <span>
                                                                                      <img v-if="filePath == ''" width="100px" src="../assets/img/DefaultUser.png" class="avatar-img"/>
                                                                                      <img v-else width="100px" :src="filePath" style="border-radius: 50%; border: 5px solid #fff" class="avatar-img"/>
                                                                                      <img src="../assets/img/edit.png" class="edit-img" style="max-width:30px" @click="triggerFileInput"/>
                                                                                      <input type="file" ref="fileInput" @change="onFileChange" style="display: none;"/>
                                                                                    </span>
                                </CCol>
                                <CCol sm="8">
                                    <h1 class="custom-28px-700 text-black text-left mt-3">
                                        <strong>{{ Name }}</strong>
                                    </h1>
                                    <p class="custom-16px-400 p-0" v-if="UserType ==='individual'">as Candidate</p>
                                </CCol>
                                <CCol sm="12" class="mt-4">
                                    <h4 class="custom-16px-600">Personal Information</h4>
                                </CCol>
                                <CCol sm="6">
                                    <label class="label-custom-header-subtitle mt-3">Name</label>
                                    <input type="text" v-model="FullName" class="custom-input-app" />
                                </CCol>
                                <CCol sm="6">
                                    <label class="label-custom-header-subtitle mt-3">Phone Number</label>
                                    <input type="text" v-model="PhoneNumber" class="custom-input-app" />
    
                                </CCol>
                                <CCol sm="12">
                                    <label class="label-custom-header-subtitle mt-3">Country</label>
    
                                    <v-select v-model="SelectedCountry" :options="country" label="CountryName"></v-select>
                                </CCol>
                                <CCol sm="12" class="mt-4">
                                    <h4 class="custom-16px-600">About Me</h4>
                                    <tinymce id="d1" v-model="AboutUsCandidate" placeholder="Enter Your Content" class="mb-2"></tinymce>
                                </CCol>
                                <CCol sm="12" class="mt-5">
                                    <h4 class="custom-16px-600">Connect</h4>
                                </CCol>
                                <CCol sm="12">
                                    <CRow class="mt-3">
                                        <CCol sm="6"><img src="../assets/img/Message.png" style="width: 30px" /><label class="custom-18px-500 font-general-sans font-color-171717 ml-3">Email</label></CCol>
                                        <CCol sm="6">
                                            <div class="text-right"><label class="custom-18px-500 font-color-928AFD text-right">{{ Email }}<img style="max-width:20px" class="ml-2" src="../assets/img/arrow-right-no-border.png" /></label></div>
                                        </CCol>
                                    </CRow>
    
                                </CCol>
                                <CCol sm="12">
                                    <div class="text-right">
                                        <label class="custom-border-purple text-white mt-2 ml-2 mt-4" @click="UpdateProfile"><label class="pl-2 pr-2 m-2">Save</label></label>
                                    </div>
                                </CCol>
    
                            </CRow>
                            <br /><br />
                        </CCard>
                    </CCol>
    
    
                </CRow>
            </CCol>
    
            <CCol sm="8" style="width: 100%; background-size: cover; margin: auto; color: #fff" class="d-md-none">
                <br /><br /><br />
                <CRow>
                    <CCol sm="12">
                        <CCard class="bg-white border-grey-card b-20">
                            <CRow class="p-20 m-3">
                                <CCol sm="12">
                                    <h4 class="custom-24px-600 font-color-171717 font-general-sans mb-5 mt-3">Edit Profile Information</h4>
                                </CCol>
                                <CCol sm="2">
                                    <span>
                                                                                      <img v-if="filePath == ''" width="100px" src="../assets/img/DefaultUser.png" class="avatar-img"/>
                                                                                      <img v-else width="100px" :src="filePath" style="border-radius: 50%; border: 5px solid #fff" class="avatar-img"/>
                                                                                      <img src="../assets/img/edit.png" class="edit-img" style="max-width:30px" @click="triggerFileInput"/>
                                                                                      <input type="file" ref="fileInput" @change="onFileChange" style="display: none;"/>
                                                                                    </span>
                                </CCol>
                                <CCol sm="8">
                                    <h1 class="custom-28px-700 text-black text-left mt-3">
                                        <strong>{{ Name }}</strong>
                                    </h1>
                                    <p class="custom-16px-400 p-0" v-if="UserType ==='individual'">as Candidate</p>
                                </CCol>
                                <CCol sm="12" class="mt-4">
                                    <h4 class="custom-16px-600">Personal Information</h4>
                                </CCol>
                                <CCol sm="6">
                                    <label class="label-custom-header-subtitle mt-3">Name</label>
                                    <input type="text" v-model="FullName" class="custom-input-app" />
                                </CCol>
                                <CCol sm="6">
                                    <label class="label-custom-header-subtitle mt-3">Phone Number</label>
                                    <input type="text" v-model="PhoneNumber" class="custom-input-app" />
    
                                </CCol>
    
                                <CCol sm="12">
                                    <label class="label-custom-header-subtitle mt-3">Country</label>
    
                                    <v-select v-model="SelectedCountry" :options="country" label="CountryName"></v-select>
    
    
                                </CCol>
    
                                <CCol sm="12" class="mt-4">
                                    <h4 class="custom-16px-600">About Me</h4>
                                    <tinymce id="d1" v-model="AboutUsCandidate" placeholder="Enter Your Content" class="mb-2" style="width: 100%;"></tinymce>
                                </CCol>
                                <CCol sm="12" class="mt-5">
                                    <h4 class="custom-16px-600">Connect</h4>
                                </CCol>
                                <CCol sm="12">
                                    <CRow class="mt-3">
                                        <CCol sm="6"><img src="../assets/img/Message.png" style="width: 30px" /><label class="custom-18px-500 font-general-sans font-color-171717 ml-3">Email</label></CCol>
                                        <CCol sm="6">
                                            <div class="text-right"><label class="custom-18px-500 font-color-928AFD text-right">{{ Email }}<img style="max-width:20px" class="ml-2" src="../assets/img/arrow-right-no-border.png" /></label></div>
                                        </CCol>
                                    </CRow>
    
                                </CCol>
                                <CCol sm="12">
                                    <div class="text-right">
                                        <label class="custom-border-purple text-white mt-2 ml-2 mt-4" @click="UpdateProfile"><label class="pl-2 pr-2 m-2">Save</label></label>
                                    </div>
                                </CCol>
    
                            </CRow>
                            <br /><br />
                        </CCard>
                    </CCol>
    
    
                </CRow>
            </CCol>
    
    
            <div v-if="isPopupSuccess" class="popup-all backdrop-all">
                <div class="popup-all1">
                    <!-- Popup content -->
                    <div class="text-center">
                        <img style="max-width: 300px" src="../assets/img/successPopup.png" />
                        <h3 class="custom-28px-500 font-color-171717 text-center mt-3">
                            Save Successfully
                        </h3>
                        <CButton class="custom-border-purple mt-4 text-white" @click="closeSuccess" style="width:100px"><span class="ml-2 mr-2">OK</span></CButton>
                    </div>
                </div>
            </div>
    
    
    
        </CCol>
        <Footerlayout></Footerlayout>
    </div>
</template>
  
<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(require("vue-moment"));
Vue.use(require("moment"));
var moment = require("moment");

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/bgPurpleYellow.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundGenie from "../assets/img/bggenie.png";
import backgroundUrNoArrow from "../assets/img/bgline.png";

import Mainlayout from "../containers/LoginHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import ToggleCard from "../components/Toggle.vue";

import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";
import _ from "lodash";

export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        ToggleCard,
    },

    data() {
        return {
            backgroundUrl,
            backgroundUrl1,
            backgroundUrNoArrow,
            backgroundGenie,
            isActive: false,
            user: {},

            filePath: '',
            FullName: '',
            PhoneNumber: '',
            Name: '',
            Email: '',
            UserType: '',
            AboutUsCandidate: '',

            isPopupSuccess: false,
            UserId: '',
            country: [],
            SelectedCountry: {},
          

        };
    },
    async mounted() {
        try {
            const isAuth = await this.UserAuth();
            if (isAuth) {
                this.GetListCountries();
                this.GetInfoUser();
            
            } else {
                this.GoToLogin();
            }
        } catch (error) {
            console.error("Error during authentication:", error);
            // Handle the error here
        }
    },
    methods: {

        async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.info = response.data;
                    this.filePath = response.data.filePath;
                    console.log("userInfo", this.user);
                    if (response.status == 200 && this.info != null) {
                        this.Name = this.info.name;
                        this.FullName = this.info.name;
                        this.PhoneNumber = this.info.phone;
                        this.Email = this.info.email;
                        this.CountryName = this.info.country;
                        this.UserType = this.info.userType;
                        this.AboutUsCandidate = this.info.aboutUsCandidate;
                        this.UserId = this.info.id;
                        this.GetListCountries();
                        this.SetupSelectedOption(this.CountryName);
                    } else {
                        console.log(this.info.detail);
                    }

                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        GetListCountries() {
            try {

                return this.$API
                .get(this.$GetListCountries)
                .then((response) => {
                    if (response.status == 200) {
                        this.country = response.data;
                    }
                });
            } catch (error) {
                console.log("eroor1" + response);
            }
        },
        SetupSelectedOption() {
  console.log("Setting selected country:", this.CountryName, this.country);
  this.SelectedCountry = _.find(this.country, { CountryName: this.CountryName });

  if (!this.SelectedCountry) {
    console.warn("Country not found:", this.CountryName);
  }
},

        triggerFileInput() {
            this.$refs.fileInput.click();
        },
        onFileChange(event) {
            const file = event.target.files[0];
            if (file) {
                this.selectedFile = file; // Store the selected file
                const reader = new FileReader();
                reader.onload = (e) => {
                    this.filePath = e.target.result;
                };
                reader.readAsDataURL(file);

                // Auto-submit the form after file selection
                this.submitProfilePicture();
            }
        },
        async submitProfilePicture() {
            if (this.selectedFile) {
                const formData = new FormData();
                formData.append('file', this.selectedFile);
                formData.append('userId', this.UserId);

                try {
                    const response = await this.$API
                        .post(this.$UploadProfilePhoto, formData, {
                            headers: {
                                'Content-Type': 'multipart/form-data',
                            },
                        });
                    console.log('Image uploaded successfully:', response.data);
                } catch (error) {
                    console.error('Error uploading image:', error);
                }
            } else {
                console.log('No file selected');
            }
        },
        UpdateProfile() {
            const formData = new FormData();

            formData.append("fullName", this.FullName);
            formData.append("phoneNumber", this.PhoneNumber);
            if(this.AboutUsCandidate != '')
            {
                formData.append("details", this.AboutUsCandidate);
            }
           

            this.$API
                .post(this.$UserDetails, formData, { withCredentials: true })
                .then((response) => {
                    if (response.data.status === 400) {
                        this.Loading = false;
                        this.Message = response.data.message;
                        this.Error = true;

                    }
                    if (response.status == 200) {
                        this.UpdateCountry();
                        if (response.data.status !== 400) {
                         
                            this.isPopupSuccess = true;
                            this.GetInfoUser();
                        } else {
                            this.Loading = false;
                            this.Message = response.data.message;
                            this.Error = true;
                        }
                    } else {
                        this.Loading = false;
                        this.Error = true;
                        this.Message = response.data.message;
                    }
                })
                .catch((error) => {
                    this.Loading = false;
                    this.Error = true;
                    this.Message = error.response.data.message;
                });

        },
        UpdateCountry() {
            const formData = new FormData();
            formData.append("countryId", this.SelectedCountry.Id);
            this.$API
                .post(this.$UpdateUserCountry, formData, { withCredentials: true })
                .then((response) => {
                    if (response.status == 200) {
                        this.GetInfoUser();
                    } else {
                        this.Loading = false;
                        this.Error = true;
                        this.Message = response.data.message;
                    }
                })
                .catch((error) => {
                    this.Loading = false;
                    this.Error = true;
                    this.Message = error.response.data.message;
                });
        },
        closeSuccess() {
            this.isPopupSuccess = false;
        },
       
     

    },
};
</script>
  
<style scoped>
@import url('https://fonts.cdnfonts.com/css/general-sans');
body {
    top: 0 !important;
    font-family: 'General Sans', sans-serif;
}
</style>
  